export default {
  fillBorder: 'Fill the entire element when displaying only the icon',
  validation: {
    iconTitleRegex: 'The field must not contain characters: $ and .',
  },
};
